module.exports = fox._r("images/bg/arrow_view.png", __webpack_public_path__ + "images/bg/arrow_view.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/bg/arrow_view.png
// module id = 991
// module chunks = 4